/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Whatsapp_Link_Dialog_DescInputs */

const he_account_delivery_whatsapp_link_dialog_desc = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סרקו את קוד ה-QR או לחצו על הכפתור כדי לפתוח את ווטסאפ ולשלוח את ההודעה`)
};

const en_account_delivery_whatsapp_link_dialog_desc = /** @type {(inputs: Account_Delivery_Whatsapp_Link_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan the QR code or tap the button to open WhatsApp and send the linking message`)
};

/**
* | output |
* | --- |
* | "Scan the QR code or tap the button to open WhatsApp and send the linking message" |
*
* @param {Account_Delivery_Whatsapp_Link_Dialog_DescInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_whatsapp_link_dialog_desc = /** @type {((inputs?: Account_Delivery_Whatsapp_Link_Dialog_DescInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Whatsapp_Link_Dialog_DescInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_whatsapp_link_dialog_desc(inputs)
	return en_account_delivery_whatsapp_link_dialog_desc(inputs)
});